import { MyGroupingOfArticlePropDTO, MoveArticlesClient, IMoveArticlesClient, IMetadataArticleClient, MetadataArticleClient, ArticleModel, ArticleMoveDTO, ArticleModelArticleType } from "../Generated/ParticaAPI";
import { ParticaItem, ParticaSubItem } from "@/Models/ParticaItem";
import { IMetadataArticle, ITOCArticle } from "@/Models/ArticleModels/article";
import { ArticleUtils } from "./articleutils";

export interface IMetadataService {
	getArticlesBySection(issueId: number): Promise<ParticaItem[]>;
	getArticle(issueId: number, articleId: string): Promise<IMetadataArticle>;
	saveArticle(article: IMetadataArticle): Promise<IMetadataArticle>;
	moveArticle(articleId: string, sectionId: number, issueId: number): Promise<any>;
	moveArticles(articleIds: string[], sectionId: number, issueId: number): Promise<any>;
	getTOCForIssue(IssueId: number): Promise<ITOCArticle[]>;
	saveTOC(data: ITOCArticle): Promise<ITOCArticle>;
	deleteArticle(article: IMetadataArticle): Promise<any>;
	saveArticles(articles: IMetadataArticle[]): Promise<any>;
}

export class MetadataService implements IMetadataService {
	private svc: IMetadataArticleClient = new MetadataArticleClient();
	private movesvc: IMoveArticlesClient = new MoveArticlesClient();
	private articleUtils: ArticleUtils = new ArticleUtils();

	public async deleteArticle(article: IMetadataArticle): Promise<any> {
		return await this.svc.deleteArticle(article.articleId, article.issueId);
	}

	public async saveArticles(articles: IMetadataArticle[]): Promise<any> {
		const ams: ArticleModel[] = [];
		articles.forEach(a => {
			const am: ArticleModel = a.get<ArticleModel>();
			am.issue = undefined;
			am.articleType = ArticleModelArticleType.Metadata;
			ams.push(am);
		});
		await this.svc.saveArticles(ams);
	}

	public async saveArticle(article: IMetadataArticle): Promise<IMetadataArticle> {
		let am = article.get<ArticleModel>();
		am.issue = undefined;
		am = await this.svc.saveArticle(am);
		return this.articleUtils.convertarticle<IMetadataArticle>(am);
	}

	public async moveArticles(articleIds: string[], sectionId: number, issueId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = articleIds;
		moveDetails.sectionId = sectionId;
		moveDetails.issueId = issueId;
		await this.movesvc.moveArticles(moveDetails);
	}
	public async moveArticle(articleId: string, sectionId: number, issueId: number) {
		const moveDetails = new ArticleMoveDTO();
		moveDetails.articleGuids = [articleId];
		moveDetails.sectionId = sectionId;
		moveDetails.issueId = issueId;
		await this.movesvc.moveArticles(moveDetails);
	}

	public async getArticle(issueId: number, articleId: string): Promise<IMetadataArticle> {
		const article: ArticleModel = await this.svc.getArticle(issueId, articleId);
		const extracted: IMetadataArticle = this.articleUtils.convertarticle<IMetadataArticle>(article);
		return extracted;
	}

	public async getArticlesBySection(issueId: number): Promise<ParticaItem[]> {
		const sections: MyGroupingOfArticlePropDTO[] = await this.svc.getArticlesBySection(issueId);
		const result: ParticaItem[] = [];
		sections.forEach(section => {
			const item: ParticaItem = { id: section.id, name: section.name, items: [], open: false, children: [] } as ParticaItem;
			if (section.elements !== undefined) {
				section.elements.forEach(element => {
					if (element.parentId !== undefined) {
						const sub: ParticaSubItem = { id: element.articleId, name: element.title, parentid: element.parentId.toString() } as ParticaSubItem;
						item.items.push(sub);
					}
				});
			}
			result.push(item);

		});
		return result;

	}

	public async getMetadataForIssue(IssueId: number): Promise<IMetadataArticle[]> {
		const articles: ArticleModel[] = await this.svc.getArticleAll(IssueId);
		return this.articleUtils.convertarticlearray<IMetadataArticle>(articles);
	}
	/*
		public async saveMetadata(data: IMetadataArticle): Promise<IMetadataArticle> {
			const model: ArticleModel = data.get<ArticleModel>();
			model.articleType = ArticleModelArticleType.Metadata;
			model.issue = undefined;
			const result: ArticleModel = await this.svc.saveArticle(model);
			return this.articleUtils.convertarticle<IMetadataArticle>(result);
		}
	*/
	public async getTOCForIssue(IssueId: number): Promise<ITOCArticle[]> {
		const articles: ArticleModel[] = await this.svc.getArticleAll(IssueId);
		return this.articleUtils.convertarticlearray<ITOCArticle>(articles);
	}

	public async saveTOC(data: ITOCArticle): Promise<ITOCArticle> {
		const model: ArticleModel = data.get<ArticleModel>();
		model.articleType = ArticleModelArticleType.Metadata;
		model.issue = undefined;
		const result: ArticleModel = await this.svc.saveArticle(model);
		return this.articleUtils.convertarticle<ITOCArticle>(result);
	}
}
